module.exports = __webpack_public_path__ + "static/media/add-family-title-deco.64128741.png";